import { render, staticRenderFns } from "./MarcaCrud.vue?vue&type=template&id=6b15a356&"
import script from "./MarcaCrud.vue?vue&type=script&lang=js&"
export * from "./MarcaCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports